import type { FontePesquisaT, StatusCotacaoT } from '@licita-mind/shared-types';
import { cn } from '../lib/cn';

const FONTE_LABELS: Readonly<Record<FontePesquisaT, string>> = {
  PNCP: 'PNCP',
  PAINEL_PRECOS: 'Painel de Preços',
  CONTRATACAO_SIMILAR_MUNICIPIO: 'contratação similar',
  SITIO_ESPECIALIZADO: 'sítio especializado',
  COTACAO_DIRETA_FORNECEDOR: 'cotação direta',
};

const FONTE_CORES: Readonly<Record<FontePesquisaT, string>> = {
  PNCP: 'bg-emerald-100 text-emerald-800',
  PAINEL_PRECOS: 'bg-teal-100 text-teal-800',
  CONTRATACAO_SIMILAR_MUNICIPIO: 'bg-blue-100 text-blue-800',
  SITIO_ESPECIALIZADO: 'bg-violet-100 text-violet-800',
  COTACAO_DIRETA_FORNECEDOR: 'bg-amber-100 text-amber-800',
};

export const FonteBadge = ({
  fonte,
  className,
}: {
  fonte: FontePesquisaT;
  className?: string;
}) => <span className={cn('badge', FONTE_CORES[fonte], className)}>{FONTE_LABELS[fonte]}</span>;

const STATUS_LABELS: Readonly<Record<StatusCotacaoT, string>> = {
  VALIDA: 'válida',
  EXCLUIDA_OUTLIER: 'outlier',
  INVALIDA_POR_IDADE: 'inválida (idade)',
  EXCLUIDA_MANUALMENTE: 'excluída',
};

const STATUS_CORES: Readonly<Record<StatusCotacaoT, string>> = {
  VALIDA: 'bg-emerald-100 text-emerald-800',
  EXCLUIDA_OUTLIER: 'bg-amber-100 text-amber-800',
  INVALIDA_POR_IDADE: 'bg-neutral-200 text-neutral-700',
  EXCLUIDA_MANUALMENTE: 'bg-red-100 text-red-700',
};

export const CotacaoStatusBadge = ({
  status,
  className,
}: {
  status: StatusCotacaoT;
  className?: string;
}) => (
  <span className={cn('badge', STATUS_CORES[status], className)}>{STATUS_LABELS[status]}</span>
);
